const cache = new Map();
export const preloadImageForSuspense = ({ src, srcSet, sizes, key }) => {
    const cacheKey = key ??
        (srcSet !== undefined && sizes !== undefined
            ? `${srcSet}-${sizes}`
            : src);
    const value = cache.get(cacheKey);
    if (value === true) {
        return value;
    }
    if (value === undefined) {
        const promise = new Promise((resolve) => {
            const img = new window.Image();
            img.onerror = img.onload = () => {
                cache.set(cacheKey, true);
                resolve(true);
            };
            if (srcSet !== undefined && sizes !== undefined) {
                img.sizes = sizes;
                img.srcset = srcSet;
            }
            else {
                img.src = src;
            }
        });
        cache.set(cacheKey, promise);
        throw promise;
    }
    throw value;
};
